<template>
  <div id="notification-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden body-module-height z-20">
    <scroll-area v-if="loaded">
      <template #header>
        <div class="w-full flex justify-start items-center h-24 md:h-12 p-1">
          <div class="w-full flex flex-col items-center md:flex-row">
            <div class="w-1/6 flex">
              <span>
                {{ $t('pages.notifications.caseId') }}
              </span>
            </div>

            <div class="w-1/6 flex">
              <span>
                {{ $t('pages.notifications.event') }}
              </span>
            </div>

            <div class="w-1/6 flex">
              <span>
                {{ $t('pages.notifications.sendedAt') }}
              </span>
            </div>

            <div class="w-1/6 flex">
              <vs-button color="primary" @click="markAllRead" class="p-1">
                {{ $t('pages.notifications.markAllRead') }}
              </vs-button>
            </div>
          </div>
        </div>
      </template>

      <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
        <li class="cursor-pointer email__mail-item" v-for="(value, key, index) in notifications" :key="key" @click="gotoNofitication(key)"
            :style="{transitionDelay: (index * 0.1) + 's'}">
          <notification-item v-model="notifications[key]" />
        </li>
      </transition-group>
    </scroll-area>
  </div>
</template>

<script>

import NotificationItem from "@/views/notifications/NotificationItem";
import NotificationService from "@/services/Notification.service";
export default {
  name: "notifications",
  components: {
    NotificationItem
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    notifications() {
      return this.$store.getters['Notifications/getNotifications']();
    }
  },
  methods: {
    gotoNofitication(ntf_id) {
      console.debug(ntf_id);
      let ntf = this.$store.getters['Notifications/getNotificationById'](ntf_id);
      this.$router.push(ntf.path);
    },
    markAllRead() {
      return NotificationService.markAllRead().then((response) => {
        if (response.updatedNtf > 0) {
          this.$store.dispatch('Notifications/setAllRead');
        }

        return Promise.resolve(true);
      });
    },
    getNotifications() {
      return NotificationService.listNotifications(0).then((response) => {
        this.$store.dispatch('Notifications/setNotifications', response.notifications);
        this.$store.dispatch('Notifications/setTotalNotifications', response.totalNtf);
        return Promise.resolve(true);
      });
    }
  },
  mounted() {
    this.getNotifications().then(() => {
      this.loaded = true;
    });
  }
}
</script>

<style>

</style>
